<template lang="pug">
    div(class="md:flex md:-mx-3")
        div(
            v-for="video in videos"
            class="w-full md:m-3 md:w-1/3 lg:w-1/4"
        )
            //- TODO: Need schema.org in the near future talk to Josh
            VideoThumb(v-if="!$device.isMobile && video.type == 'YOUTUBE'" :video="video" @click.native="currentVideo = video;show = true")
            WistiaThumb(v-if="video.type == 'WISTIA'" :video="video")
            //- For YouTube/Mobile, just inline the videos, no thumbs
            Video(v-if="$device.isMobile && video.type == 'YOUTUBE'" :video="video")
        //- For YouTube/Desktop, we have to make our own lightbox :(
        VideoLightbox(:video="currentVideo" v-if="show && !$device.isMobile" @close="show = false")
</template>
<script>
import Video from '@/components/video'
import VideoThumb from '@/components/video/thumb'
import WistiaThumb from '@/integrations/wistia/thumb'
const VideoLightbox = () =>
    import(/* webpackChunkName: "youtube-lightbox" */ '@/components/video/lightbox')

export default {
    name: 'VideoList',
    components: {
        VideoThumb,
        WistiaThumb,
        VideoLightbox,
        Video,
    },
    props: {
        videos: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            show: false,
            currentVideo: null,
        }
    },
}
</script>

<style lang="stylus" scoped>
+mobile-only()
    iframe
        width 100%
        height auto
</style>
